














// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
import { ViewSessionProgress } from "@/components.studies/view-session-progress";
// local
import { default as SessionBreadcrumbs } from "./session-breadcrumbs.vue";

export default defineComponent({
	components:{
		SessionBreadcrumbs,
		ViewSessionProgress
	},
	setup(props, context){
		const sessionId = computed(() => context.root.$route.params["sessionId"]);
		const studyId = computed(() => context.root.$route.params["groupId"]);
		const backRoute = computed(() => {
			return {
				name: "Run.Group.Live",
				params:{
					groupId:studyId.value
				}
			};
		});
		return {
			sessionId,
			studyId,
			backRoute
		};
	}
	
});

